const Mochilas = {
  mochilas: [
    {
      id: 1,
      path:"/productos-mochilas",
      cover: "./images/mochilas/1-mochila.jpg",
      cover1: "./images/mochilas/1-mochila-color.jpg",
      cover2: "./images/mochilas/1-mochila-4fotos.jpg",
      name: "Mochila",
      description: "Este reloj de pared es un accesorio moderno y minimalista con bordes negros, hecho de plástico duro, resistente a golpes y caídas. Los números de tamaño normal son fáciles de leer, y funciona con una pila doble A. Fácil de instalar con su soporte para colgar, y su tamaño de 200x200mm lo hace perfecto para cualquier pared estándar. Un producto elegante y funcional para decorar cualquier ambiente.",
      price: "M1",
      discount: "2",
    },
    {
      id: 2,
      path:"/productos-mochilas",
      cover: "./images/mochilas/2-mochila.jpg",
      cover1: "./images/mochilas/2-mochila-logo.jpg",
      cover2: "./images/mochilas/2-mochila-4fotos.jpg",
      name: "Mochila",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "M2",
      discount: "2",
    },
    {
      id: 3,
      path:"/productos-mochilas",
      cover: "./images/mochilas/3-mochila.jpg",
      cover1: "./images/mochilas/3-mochila-logo.jpg",
      cover2: "./images/mochilas/3-mochila-4fotos.jpg",
      name: "Mochila",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "P3",
      discount: "2",
    },
    {
      id: 4,
      path:"/productos-mochilas",
      cover: "./images/mochilas/4-mochila.jpg",
      cover1: "./images/mochilas/4-mochila-logo.jpg",
      cover2: "./images/mochilas/4-mochila-colores.jpg",
      name: "Mochila",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "M4",
      discount: "2",
    },
    {
      id: 5,
      path:"/productos-mochilas",
      cover: "./images/mochilas/5-mochila.jpg",
      cover1: "./images/mochilas/5-mochila-logo.jpg",
      cover2: "./images/mochilas/5-mochila-4fotos.jpg",
      name: "Mochila",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "M5",
      discount: "2",
    },
  ],
}
export default Mochilas
